/* subscription section */
$(
  ".subscription-section-slider-slide-second .subscription-slide-points li"
).click(function (e) {
  e.preventDefault();
  $(
    ".subscription-section-slider-slide-second .subscription-slide-points li"
  ).removeClass("active");
  $(this).addClass("active");
});
$(".subscription-section-bottom .column-footer-button").click(function (e) {
  e.preventDefault();
  var selling_plan;
  var vid = $(this).attr("data-vid");
  if ($(".data-plan1").hasClass("active")) {
    selling_plan = $(this).attr("data-sellingplan1");
  } else if ($(".data-plan2").hasClass("active")) {
    selling_plan = $(this).attr("data-sellingplan2");
  } else if ($(".data-plan3").hasClass("active")) {
    selling_plan = $(this).attr("data-sellingplan3");
  }
  addItemToCart(vid, 1, selling_plan);
});
function addItemToCart(variant_id, qty, selling_plan) {
  data = {
    id: variant_id,
    quantity: qty,
    selling_plan: selling_plan,
  };
  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function () {},
  });
}

function mobileOnlySlider(
  $slidername,
  $dots,
  $arrows,
  $breakpoint,
  $autoplay,
  $autoplayspeed
) {
  var slider = $($slidername);
  var settings = {
    mobileFirst: true,
    dots: $dots,
    arrows: $arrows,
    autoplay: $autoplay,
    autoplaySpeed: $autoplayspeed,
    adaptiveHeight: true,
    slidesToShow: 1,
    infinite: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          variableWidth: true,
        },
      },
      {
        breakpoint: $breakpoint,
        settings: "unslick",
      },
    ],
  };

  slider.slick(settings);

  $(window).on("resize", function () {
    if ($(window).width() > $breakpoint) {
      return;
    }
    if (!slider.hasClass("slick-initialized")) {
      return slider.slick(settings);
    }
  });
}
mobileOnlySlider(
  ".subscription-section-slider",
  true,
  false,
  1050,
  false,
  1000
);

/* subscription section */

function trimElements() {
  var elements = document.querySelectorAll(".cssVar-reviewStatistics");
  elements.forEach(function (element) {
    var trimmedText = element.textContent.trim();
    element.textContent = trimmedText;
  });
}

var intervalId = setInterval(trimElements, 100);
setTimeout(function () {
  clearInterval(intervalId);
}, 3000);

function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."),
      dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      ),
      centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

try {
  function updateSubsPrice() {
    const currencyFormat = window.themeVariables.settings.currencyCodeEnabled
      ? window.themeVariables.settings.moneyWithCurrencyFormat
      : window.themeVariables.settings.moneyFormat;
    if ($(".rc-option--active[data-option-subsave]").length === 1) {
      if (!$(".price-list .price.price--compare").length) {
        var cp = $(".product__info .price_.price--large").attr("data-price");
        if (cp) {
          var disEl = document.querySelector(
            ".rc_widget__option__discount"
          ).textContent;
          var disP = parseFloat(disEl);
          if (disP) {
            var saveAmount = (disP / 100) * cp;
            $(".product__info .price_").text(
              formatMoney(cp - saveAmount, currencyFormat)
            );
            saveAmount = formatMoney(saveAmount, currencyFormat);

            var rowcp = cp;
            cp = formatMoney(cp, currencyFormat);

            $(".product__info .price-list").prepend(
              `<span class="price price--compare ssp" data-p="${rowcp}">${cp}</span>`
            );
            $(".product__info .product-meta__label-list").append(
              `<span class="label label--highlight ssp"><span class="ed-save-amount">${saveAmount}</span> gespart</span>`
            );
            var element = document.querySelector(".unit_price_of_product");
            if (element) {
              var originalValueWithComma = element.getAttribute("data-unit");
              var originalValueWithDot = originalValueWithComma.replace(
                ",",
                "."
              );
              var originalValue = parseFloat(originalValueWithDot);
              var disV = (100 - disP) / 100;
              var reducedValue = originalValue * disV;
              element.textContent =
                reducedValue.toFixed(2).replace(".", ",") +
                "/" +
                originalValueWithComma.split("/")[1];
            }
          }
        }
      }
    } else {
      var elements = document.querySelectorAll(".ssp");
      var elementsArray = Array.from(elements);
      elementsArray.forEach(function (element) {
        element.parentNode.removeChild(element);
      });

      // var cp = $(".product__info .price_").attr("data-price");
      // $(".product__info .price_").text(formatMoney(cp, currencyFormat));
    }
  }
  $(document).on("click", ".rc-option__onetime", function () {
    const currencyFormat = window.themeVariables.settings.currencyCodeEnabled
      ? window.themeVariables.settings.moneyWithCurrencyFormat
      : window.themeVariables.settings.moneyFormat;
    var elements = document.querySelectorAll(".ssp");
    var elementsArray = Array.from(elements);
    elementsArray.forEach(function (element) {
      element.parentNode.removeChild(element);
    });

    // var cp = $(".product__info .price_").attr("data-price");
    // $(".product__info .price_").text(formatMoney(cp, currencyFormat));
  });

  setInterval(function () {
    if ($(".rc-option--active[data-option-subsave]").length === 1) {
      updateSubsPrice();
    }
  }, 1);
} catch (e) {}
try {
  $(document).ready(function () {
    $(document).on("click", "[data-option-subsave]", function () {
      const currencyFormat = window.themeVariables.settings.currencyCodeEnabled
        ? window.themeVariables.settings.moneyWithCurrencyFormat
        : window.themeVariables.settings.moneyFormat;

      var disEl = document.querySelector(
        ".rc_widget__option__discount"
      ).textContent;
      var disP = parseFloat(disEl);
      if (disP) {
        var p = Number(
          $("[data-product-price-list] .price_").attr("data-price")
        );
        var cp = Number(
          $("[data-product-price-list] .price.price--compare").attr("data-p")
        );
        var twentyPercent = disP / 100;
        var result = p - p * twentyPercent;
        var final_price = result / 100;
        cp = cp / 100;
        cp = cp - final_price;
        var save = formatMoney(cp * 100, currencyFormat);
        final_price = formatMoney(final_price * 100, currencyFormat);
        $("[data-product-price-list] .price_").text(final_price);
        if (cp) {
          $(".ed-save-amount").text(save);
        }

        var element = document.querySelector(".unit_price_of_product");
        if (element) {
          var originalValueWithComma = element.getAttribute("data-unit");
          var originalValueWithDot = originalValueWithComma.replace(",", ".");
          var originalValue = parseFloat(originalValueWithDot);
          var disV = (100 - disP) / 100;
          var reducedValue = originalValue * disV;
          element.textContent =
            reducedValue.toFixed(2).replace(".", ",") +
            "/" +
            originalValueWithComma.split("/")[1];
        }
      }
    });

    $(document).on("click", "[data-option-onetime]", function () {
      const currencyFormat = window.themeVariables.settings.currencyCodeEnabled
        ? window.themeVariables.settings.moneyWithCurrencyFormat
        : window.themeVariables.settings.moneyFormat;
      var disEl = document.querySelector(
        ".rc_widget__option__discount"
      ).textContent;
      var disP = parseFloat(disEl);
      if (disP) {
        var p = Number(
          $("[data-product-price-list] .price_").attr("data-price")
        );

        var cp = Number(
          $("[data-product-price-list] .price.price--compare").attr("data-p")
        );

        var save = cp - p;
        save = formatMoney(save, currencyFormat);
        var final_price = formatMoney(p, currencyFormat);

        $("[data-product-price-list] .price_").text(final_price);

        $(".ed-save-amount").text(save);

        var element = document.querySelector(".unit_price_of_product");

        if (element) {
          var originalValueWithComma = element.getAttribute("data-unit");
          element.textContent = originalValueWithComma;
        }
      }
    });
  });
} catch (e) {}

$(document).on(
  "click",
  ".rebuy-cart__flyout-empty-cart .ql-align-center a",
  function (e) {
    e.preventDefault();
    window.location.href = "/collections/all";
  }
);
$(function () {
  $(".product-info-button-container").click(function (event) {
    event.stopPropagation();
  });

  $(".tab-link").click(function (e) {
    e.preventDefault();
    $(".tab-link").removeClass("current");
    $(".tab-content").removeClass("current");
    $(this).addClass("current");
    $(`#${$(this).attr("data-tab")}`).addClass("current");
  });
});

/* coupon block */
const copyButton = document.querySelector(
  ".coupon-code__wrapper .coupon-code__button"
);
const couponCode = document.querySelector(
  ".coupon-code__wrapper .coupon-code__code"
);
const successMessage = document.querySelector(
  ".coupon-code__wrapper .coupon-code__success-message"
);

copyButton.addEventListener("click", function () {
  navigator.clipboard.writeText(couponCode.innerText).then(
    () => {
      successMessage.classList.add("active");
      setTimeout(() => {
        successMessage.classList.remove("active");
      }, 2000);
    },
    (error) => console.log("error copying coupon code")
  );
});
